export const MANAGE_INTEGRATIONS_PATH = "manage/:provider";
export const EDIT_INTEGRATIONS_PATH = "edit/:provider/:id";
export const BUILT_IN_GITHUB_INTEGRATION_NAME = "GitHub built-in integration";
export const ORIGIN_INTEGRATION_NAME = "Origin integration";
